import Sidebar from "@/components/Sidebar/SidebarView.vue";
import Navbar from "@/components/Navbar/NavbarView.vue";
import InactivityModal from "@/components/InactivityTracker/InactivityTracker.vue";
import { get_token } from "@/router";
import Swal from "sweetalert2";
import {
  format_currency,
  format_date,
  get_campaign_raised_amount,
  get_campaign_summary,
  get_progress,
} from "@/views/DonationCampaigns/donation_campaigns_methods_helper";

export default {
  name: "DonationCampaignDashboardView",
  components: {
    Sidebar,
    Navbar,
    InactivityModal,
  },
  data() {
    return ({
      campaigns: [],
      is_loading: false,
    });
  },
  computed: {
    total_raised_amount() {
      return this.campaigns.reduce(
        (total, campaign) => total + Number(this.get_campaign_raised_amount(campaign) || 0),
        0
      );
    },
    total_goal_amount() {
      return this.campaigns.reduce(
        (total, campaign) => total + Number(campaign?.goal_amount || 0),
        0
      );
    },
    total_donations_count() {
      return this.campaigns.reduce((total, campaign) => {
        const completed_donations = Array.isArray(campaign?.donations)
          ? campaign.donations.filter(
            (donation) => String(donation?.donation_status || "").toLowerCase() === "completed"
          )
          : [];

        return total + completed_donations.length;
      }, 0);
    },
    active_campaigns_count() {
      return this.campaigns.filter(
        (campaign) => String(campaign?.status || "").toLowerCase() === "active"
      ).length;
    },
  },
  mounted() {
    this.fetch_campaigns();
  },
  methods: {
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle("close");
    },
    getToken() {
      return get_token();
    },
    get_request_headers() {
      return ({
        Authorization: `Token ${this.getToken()}`,
      });
    },
    init_campaigns_datatable() {
      const table_id = "#campaignDashboardTable";
      const table = $(table_id);

      if (!table.length || !$.fn.DataTable) {
        return;
      }

      if ($.fn.DataTable.isDataTable(table_id)) {
        table.DataTable().clear().destroy();
      }

      table.DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        lengthChange: true,
        pageLength: 10,
        order: [[5, "desc"]],
        language: {
          paginate: {
            previous: "Previous",
            next: "Next",
          },
          info: "Showing _START_ to _END_ of _TOTAL_ campaigns",
          infoEmpty: "No campaigns available",
          emptyTable: "No campaigns available",
        },
      });
    },
    fetch_campaigns() {
      this.is_loading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/donation_management/get_campaigns/`,
        method: "GET",
        headers: this.get_request_headers(),
        success: (response) => {
          this.campaigns = response?.data || [];
          this.$nextTick(() => {
            this.init_campaigns_datatable();
          });
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "Unable to load campaigns.",
            showConfirmButton: false,
            timer: 2200,
            position: "bottom-end",
            toast: true,
          });
        },
        complete: () => {
          this.is_loading = false;
        },
      });
    },
    open_campaign(campaign) {
      if (!campaign?.id) {
        return;
      }

      this.$router.push({
        name: "donation_campaigns",
        query: { campaign_id: campaign.id },
      });
    },
    get_campaign_donor_count(campaign) {
      if (!Array.isArray(campaign?.donations)) {
        return 0;
      }

      return campaign.donations.filter(
        (donation) => String(donation?.donation_status || "").toLowerCase() === "completed"
      ).length;
    },
    format_currency,
    format_date,
    get_campaign_summary,
    get_campaign_raised_amount,
    get_progress,
  },
};
